/* eslint-disable eqeqeq */
import * as React from "react";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./App.scss";
import { Button } from "react-bootstrap";
import { handleShow, setLargeDevice } from "../store/reducers/reducer-sidebar";
import { AuthProvider } from "../auth/context/AuthProvider";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import SSLNavbar from "../components/Navbar";
import LoginForm from "../pages/Login";
import "react-toastify/dist/ReactToastify.css";
import RouterComp from "../Router";
import useLogout from "../hooks/useLogout";
import Profile from "../pages/Profile/Profile";
import ChangePassword from "../pages/Profile/ChangePassword";
import EditProfile from "../pages/Profile/EditProfile";
import { roleType } from "../Utils/constant";
import EnrollComp from "../pages/EnrollComp";
import Register from "../pages/Register";

let stylingObject = {
  menuButton: {
    position: "fixed",
    top: 0,
    left: 0,
  },
};
export default function App() {
  const [path, setPath] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  // useEffect(() => {
  //   if (selectedAccount && selectedRole === roleType.lender) {
  //     const filtered = userDetails?.account?.filter(
  //       (acc) => acc.recid === selectedAccount.value
  //     );
  //     if (filtered && filtered.length > 0) {
  //       const achPresent = filtered[0]?.ach_w9;
  //       if (achPresent !== "PRESENT") {
  //         navigate("/manage-account");
  //         setPath(true);
  //       } else {
  //         setPath(false);
  //       }
  //     }
  //   } else {
  //     setPath(false);
  //   }
  // }, [selectedAccount, selectedRole]);

  useEffect(() => {
    if (!selectedAccount) {
      navigate("/add_account");
    }
  }, [selectedAccount]);

  React.useEffect(() => {
    if (
      localStorage.getItem("authentication") == null &&
      location.pathname != "/login" &&
      !location.pathname.includes("register") &&
      location.pathname != "/new-user-admission" &&
      location.pathname != "/masquerade" &&
      location.pathname != "/enroll" &&
      location.pathname != "/apps" &&
      location.pathname != "/borrower-onboarding" &&
      location.pathname != "/reset-password" &&
      !location.pathname.includes("/unsubscribe") &&
      location.pathname != "/partnerflow/login" &&
      !location.pathname.includes("/verification-form") &&
      !location.pathname.includes("/thankyou") &&
      location.pathname != "/vom-gateway" &&
      !location.pathname.includes("/vom") &&
      !location.pathname.includes("/vom-details") &&
      !location.pathname.includes("/vom/borrower") &&
      !location.pathname.includes("/vom-details/external") &&
      !location.pathname.includes("/feedback") &&
      location.pathname != "/payoff-gateway" &&
      location.pathname != "/payoff-requests" &&
      location.pathname != "/payoff-request-form" && 
      location.pathname != "/payoff-request/details" &&
      location.pathname != "/payoff/duplicate" &&
      location.pathname != "/payoff/invalid" &&
      location.pathname != "/payoff-gateway-authorize" &&
      location.pathname != "/unauthorize-payoff-access" &&
      location.pathname != "/invalid-payoff-link" &&
      location.pathname != "/payoff-borrower-authorization" &&
      location.pathname != "/authorize-requests"

      // &&
      // location.pathname != "/newregister"
    ) {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      dispatch(setLargeDevice(window.innerWidth >= 992)); // 992px is the breakpoint for "lg" devices in Bootstrap
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const configuration = {
    auth: {
      clientId: "2adcef6f-4c18-42dd-be75-ab5b9764c8e9",
      authority:
        "https://login.microsoftonline.com/7d20aec7-6f8b-4e0b-a4d2-9b4b1405f427",
    },
  };
  const handleIdle = () => {
    logout();
    alert("You have been signed out due to inactivity.");
  };

  useIdleTimer(handleIdle);
  const pca = new PublicClientApplication(configuration);
  return (
    <div className="App">
      <Button
        hidden
        onClick={() => {
          dispatch(handleShow());
        }}
        style={stylingObject.menuButton}
      >
        Open
      </Button>
      <MsalProvider instance={pca}>
        <AuthProvider>
          {path === false ? (
            <RouterComp />
          ) : (
            <>
              <SSLNavbar sideBar={false} showNavButtons={false} />
              <Routes>
                <Route path="/login" element={<LoginForm />} />
                <Route path="/enroll" element={<EnrollComp />} />
                <Route
                  path="/manage-account"
                  element={
                    <div
                      className="text-start px-5 rounded"
                      style={{ background: "#eeeeee" }}
                    >
                      <Profile />
                    </div>
                  }
                />
                <Route path="/manage-account/edit" element={<EditProfile />} />
                <Route
                  path="/manage-account/change-password"
                  element={<ChangePassword />}
                />
              </Routes>
            </>
          )}
        </AuthProvider>
      </MsalProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="light"
      />
    </div>
  );
}
const useIdleTimer = (onIdle, timeout = 1800000) => {
  const timeoutId = React.useRef(null);

  const resetTimer = React.useCallback(() => {
    clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(onIdle, timeout);
  }, [onIdle, timeout]);

  React.useEffect(() => {
    // Set up event listeners
    document.addEventListener("mousemove", resetTimer);
    document.addEventListener("keypress", resetTimer);
    document.addEventListener("click", resetTimer);
    document.addEventListener("scroll", resetTimer);

    // Set the initial timer
    resetTimer();

    // Clean up
    return () => {
      clearTimeout(timeoutId.current);
      document.removeEventListener("mousemove", resetTimer);
      document.removeEventListener("keypress", resetTimer);
      document.removeEventListener("click", resetTimer);
      document.removeEventListener("scroll", resetTimer);
    };
  }, [resetTimer]);

  return resetTimer;
};
